import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconTickFillSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.04 13.36c.2-.2.52-.2.71 0l2.5 2.59c.2.2.2.5 0 .7L21.12 34.83c-.91.91-2.37.89-3.25-.05L9.34 25.7a.5.5 0 01.01-.7l2.58-2.5a.5.5 0 01.71.01l6.92 7.37 16.48-16.52z"
  }));
}
var TUXIconTickFillSmall = withTUXIcon(IconTickFillSmall);

export default IconTickFillSmall;
export { TUXIconTickFillSmall };
